import { map } from 'rxjs';

export interface HALResponse<K> {
	data: K;
	meta: never;
	_links: Record<string, { href: string }>;
}

export interface HALWithPaginationResponse<K> {
	data: K;
	pagination: PaginationInterface;
	meta: never;
	_links: Record<string, { href: string }>;
}

export interface PaginationInterface {
	pageNumber: number;
	pageSize: number;
	totalPages: number;
	totalRecords: number;
}

export const stripHAL = map(<T>(object: HALResponse<T>) => {
	return object.data;
});
